const firebaseConfig = {
  apiKey: 'AIzaSyBfGZDkao0Kylnip8rE1x6TwvJFSL9X5sQ',
  authDomain: 'southwire-configurator-44b25.firebaseapp.com',
  databaseURL: 'https://southwire-configurator-44b25.firebaseio.com',
  projectId: 'southwire-configurator-44b25'
};

export default firebaseConfig;
